import PATHS from '../constants';

function fetchProjectDetails(id) {
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    };
    return fetch(PATHS.PROJECT_DETAILS(id), {
        method: 'GET',
        dataType: 'json',
        headers,
    });
};

export default fetchProjectDetails;